// 社区帖子模块 枚举与展示函数
// 对齐 docs/接口文档.md 7.3 社区帖子（后端 PostService，tb_post / tb_post_comment）
//
// 产品逻辑：
//  - 帖子由 C 端用户自行发布，社区【没有审核机制】——发布即在小程序端展示。
//    管理端不做审核 / 上下架，只保留「删除」（对应 DB 的 deleted = 1）。
//  - 运营方持有独立官方账号（C 端 user_id = 0），可发帖、回复他人留言，
//    并具备删除帖子 / 删除单条留言的治理权限。
//  - 帖子结构 = 标题 + 正文 + 媒体，媒体三选一：图文（最多 6 张）/ 横版视频 / 竖版视频。
//  - 列表 / 详情接口已直接附带 nickname / is_official（user_id=0 固定官方昵称），
//    前端不再维护用户表 mock。

// 官方运营账号（固定 tb_user ID 1，与后端 PostCode 对齐）
export const OFFICIAL_USER = {
  id: 1,
  nickname: '圣山塔林官方',
  is_official: 1
}

// 帖子形式 tb_post.type：1 图文 2 横版视频 3 竖版视频
export const POST_TYPE = [
  { value: 1, label: '图文' },
  { value: 2, label: '横版视频' },
  { value: 3, label: '竖版视频' }
]

// 产品规则：图文帖最多可上传的图片张数
export const POST_MAX_IMAGES = 6

// 帖子形式 → 中文
export function postTypeLabel(value) {
  const item = POST_TYPE.find(t => t.value === value)
  return item ? item.label : '未知'
}

// 视频时长：225 → "03:45"
export function formatDuration(seconds) {
  const total = Number(seconds) || 0
  if (total <= 0) return ''
  const m = Math.floor(total / 60)
  const s = total % 60
  const pad = n => String(n).padStart(2, '0')
  return `${pad(m)}:${pad(s)}`
}

// 媒体概览文案：图文"图 3 张" / 视频"视频 03:45"
export function postMediaText(row) {
  if (row.type === 1) {
    const n = (row.images || []).length
    return n ? `图 ${n} 张` : '纯文字'
  }
  const d = formatDuration(row.duration)
  return d ? `视频 ${d}` : '视频'
}
